<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'relatorio-pro-vencimento') {
            next({ name: 'relatorio-pro-vencimento-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'relatorio-pro-vencimento') {
            this.$router.push({ name: 'relatorio-pro-vencimento-list' });
        }
    },
};
</script>
